<div class="container-box">
  <app-table-header tableTitle="Grandi Acquirenti" (btnUpdateClick)="loadBigBuyers()">
    <app-button-new-big-buyers action-button></app-button-new-big-buyers>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="bigBuyersTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
